
/* ================================================================
   Reiselieblinge – Rechtliche Hinweise (shopweit)
   1) Preishinweis unter jedem sichtbaren (nicht durchgestrichenen) Preis:
      digitale Guides: "inkl. MwSt. · keine Versandkosten"
      physische Ware:  "inkl. MwSt. zzgl. Versandkosten" (Link zur Versandseite)
      – entfällt, wenn das Theme dort bereits einen MwSt.-Hinweis zeigt
   2) Dezentes "KI"-Label oben rechts – NUR bei Bildern,
      deren Alt-Text "KI-generiert" enthält (pro Bild im Shopify-Admin steuerbar).
      Klick auf das Label oeffnet einen kurzen Hinweis.
   ================================================================ */
(function () {
  if (window.__rlHinweise) return;
  window.__rlHinweise = true;

  var css =
    '.rl-tax-note{display:block;margin-top:4px;white-space:nowrap}' +
    '.rl-tax-note a{color:inherit !important;text-decoration:underline !important;font:inherit !important}' +
    '.rl-ki-badge{position:absolute !important;z-index:50 !important;background:rgba(48,38,31,.34) !important;-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);color:rgba(255,255,255,.95) !important;font-family:var(--font-body-family) !important;font-size:10px !important;line-height:1 !important;font-weight:600 !important;font-style:normal !important;letter-spacing:.08em !important;text-transform:none !important;padding:4px 7px !important;margin:0 !important;border:0 !important;border-radius:4px !important;pointer-events:auto !important;cursor:pointer !important;white-space:nowrap !important;box-shadow:none !important;outline:none !important;transition:background .2s}' +
    '.rl-ki-badge:hover{background:rgba(48,38,31,.55) !important}' +
    '.rl-ki-badge:focus-visible{outline:2px solid #fff !important;outline-offset:2px !important}' +
    '.rl-ki-ov{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(23,19,16,.38);opacity:0;transition:opacity .2s}' +
    '.rl-ki-ov.is-open{opacity:1}' +
    '.rl-ki-dlg{width:100%;max-width:440px;overflow:hidden;border-radius:18px;background:#FBF7F2;color:#171310;font-family:var(--font-body-family);box-shadow:0 30px 60px -30px rgba(23,19,16,.55);transform:translateY(6px);transition:transform .2s}' +
    '.rl-ki-ov.is-open .rl-ki-dlg{transform:none}' +
    '.rl-ki-hd{display:flex;align-items:center;justify-content:space-between;gap:16px;padding:16px 16px 14px 24px;border-bottom:1px solid rgba(190,155,125,.28)}' +
    '.rl-ki-hd h2{margin:0;font-family:var(--font-heading-family);font-weight:560;font-size:20px;line-height:1.2;letter-spacing:-.02em;color:#171310}' +
    '.rl-ki-x{flex:0 0 auto;display:grid;place-items:center;width:36px;height:36px;margin:0;padding:0;border:1px solid rgba(190,155,125,.4);border-radius:50%;background:#fff;color:#171310;cursor:pointer;outline:none;transition:border-color .2s}' +
    '.rl-ki-x:hover{border-color:#9C7556}' +
    '.rl-ki-x:focus-visible{outline:2px solid #9C7556;outline-offset:2px}' +
    '.rl-ki-x svg{width:13px;height:13px;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round}' +
    '.rl-ki-dlg p{margin:0;padding:18px 24px 24px;font-size:14.5px;line-height:1.65;letter-spacing:.01em;color:rgba(23,19,16,.75)}';
  var st = document.createElement('style');
  st.id = 'rl-hinweise-css';
  st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  var IS_EN = /^en/i.test(document.documentElement.lang || '');
  var PRICE_RE = /^(€\d{1,3}(\.\d{3})*,\d{2}|\d{1,3}(\.\d{3})*,\d{2}€)$/;
  var TAX_RE = /inkl\.?\s*(mwst|ust|umsatzsteuer)|incl\.?\s*vat|tax(es)? included/i;
  function squash(s) { return (s || '').replace(/[\s  ]+/g, ''); }

  function isStruck(el) {
    var n = el, i = 0;
    while (n && n.nodeType === 1 && i < 3) {
      var td = getComputedStyle(n).textDecorationLine || getComputedStyle(n).textDecoration || '';
      if (td.indexOf('line-through') !== -1) return true;
      n = n.parentElement; i++;
    }
    return false;
  }

  function textWithoutOurNotes(node) {
    var c = node.cloneNode(true);
    var ours = c.querySelectorAll('.rl-tax-note,.rl-ki-badge');
    for (var i = 0; i < ours.length; i++) ours[i].remove();
    return c.textContent || '';
  }

  function hasExistingTaxNote(el) {
    var n = el.parentElement, i = 0;
    while (n && i < 3) {
      var t = textWithoutOurNotes(n);
      if (t.length < 800 && TAX_RE.test(t)) return true;
      n = n.parentElement; i++;
    }
    return false;
  }

  function findThemeTaxEl(el) {
    var n = el.parentElement, lvl = 0;
    while (n && lvl < 4) {
      if (textWithoutOurNotes(n).length > 2500) break;
      var cand = n.querySelectorAll('p,span,div,small,li,dd');
      for (var i = 0; i < cand.length; i++) {
        var c = cand[i];
        if (c.classList.contains('rl-tax-note') || c.closest('.rl-tax-note') || c.hasAttribute('data-rl-tax-theme')) continue;
        var t = textWithoutOurNotes(c).replace(/\s+/g, ' ').trim();
        if (t.length > 80 || !TAX_RE.test(t)) continue;
        var deeper = false;
        for (var k = 0; k < c.children.length; k++) { if (TAX_RE.test(c.children[k].textContent || '')) { deeper = true; break; } }
        if (deeper) continue;
        return c;
      }
      n = n.parentElement; lvl++;
    }
    return null;
  }

  function findFollowingTax(el) {
    var n = el, lvl = 0;
    while (n && lvl < 4) {
      var sib = n.nextElementSibling, cnt = 0;
      while (sib && cnt < 3) {
        if (!sib.classList.contains('rl-tax-note')) {
          var t = textWithoutOurNotes(sib).replace(/\s+/g, ' ').trim();
          if (t.length <= 120 && TAX_RE.test(t)) {
            var best = sib, cand = sib.querySelectorAll('*');
            for (var i = 0; i < cand.length; i++) {
              var ct = textWithoutOurNotes(cand[i]).replace(/\s+/g, ' ').trim();
              if (TAX_RE.test(ct) && ct.length <= t.length) best = cand[i];
            }
            if (!best.closest('.rl-tax-note')) return best;
          }
        }
        sib = sib.nextElementSibling; cnt++;
      }
      n = n.parentElement; lvl++;
    }
    return null;
  }

  function fillNote(s, digital) {
    while (s.firstChild) s.removeChild(s.firstChild);
    if (digital) {
      s.appendChild(document.createTextNode(IS_EN ? 'incl. VAT · no shipping costs' : 'inkl. MwSt. · keine Versandkosten'));
    } else {
      s.appendChild(document.createTextNode(IS_EN ? 'incl. VAT, plus ' : 'inkl. MwSt. zzgl. '));
      var a = document.createElement('a');
      a.href = '/policies/shipping-policy';
      a.textContent = IS_EN ? 'shipping' : 'Versandkosten';
      a.style.setProperty('color', 'inherit', 'important');
      a.style.setProperty('text-decoration', 'underline', 'important');
      s.appendChild(a);
    }
  }

  function isDigitalContext(el) {
    var n = el, i = 0;
    while (n && i < 6) {
      var t = textWithoutOurNotes(n);
      if (t.length < 3000) {
        var phys = /neckdream|kissen|nackenst/i.test(t);
        var dig = /digital|download|pdf|reiseguide/i.test(t);
        if (phys && !dig) return false;
        if (dig && !phys) return true;
        if (phys && dig) return /reiseguide/i.test(location.pathname) ? true : !/neckdream|kissen|nackenst/i.test(document.title) && /reiseguide/i.test(document.title);
      }
      n = n.parentElement; i++;
    }
    return /reiseguide/i.test(location.pathname + ' ' + document.title) && !/neckdream|kissen/i.test(document.title);
  }

  var STYLE_KEYS = ['font-family','font-size','font-weight','font-style','letter-spacing','line-height','color','text-transform'];
  var noteStyle = null;
  try { noteStyle = JSON.parse(localStorage.getItem('rlTaxStyle') || 'null'); } catch (e) {}
  function captureStyle(el) {
    var cs = getComputedStyle(el), o = {};
    for (var i = 0; i < STYLE_KEYS.length; i++) o[STYLE_KEYS[i]] = cs.getPropertyValue(STYLE_KEYS[i]);
    noteStyle = o;
    try { localStorage.setItem('rlTaxStyle', JSON.stringify(o)); } catch (e) {}
  }
  function styleNote(s) {
    var o = noteStyle || {
      'font-family': 'var(--font-body-family)', 'font-size': '13px', 'font-weight': '400', 'font-style': 'normal',
      'letter-spacing': '.02em', 'line-height': '1.5', 'color': 'rgba(var(--color-base-text),.65)', 'text-transform': 'none'
    };
    for (var k in o) { if (o[k]) s.style.setProperty(k, o[k], 'important'); }
    s.style.setProperty('opacity', '1', 'important');
    s.style.setProperty('text-decoration', 'none', 'important');
  }
  function linkify(el) {
    if (el.querySelector('a')) return;
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) {
      var idx = n.nodeValue.search(/Versandkosten|Versand|shipping/i);
      if (idx === -1) continue;
      var word = n.nodeValue.match(/Versandkosten|Versand|shipping/i)[0];
      var after = n.splitText(idx); after.splitText(word.length);
      var a = document.createElement('a');
      a.href = '/policies/shipping-policy';
      a.textContent = word;
      a.style.setProperty('color', 'inherit', 'important');
      a.style.setProperty('font', 'inherit', 'important');
      a.style.setProperty('text-decoration', 'underline', 'important');
      a.style.setProperty('text-decoration-thickness', '1px', 'important');
      a.style.setProperty('text-underline-offset', '2px', 'important');
      after.parentNode.replaceChild(a, after);
      return;
    }
  }
  function fixPriceOrder(el) {
    var row = el.parentElement, depth = 0, itemCur = el;
    while (row && depth < 3 && !isFlexRow(row)) { itemCur = row; row = row.parentElement; depth++; }
    if (!row || !isFlexRow(row)) return;
    var kids = row.children, itemOld = null;
    for (var i = 0; i < kids.length; i++) {
      var c = kids[i];
      if (c === itemCur) break;
      if (PRICE_RE.test(squash(textWithoutOurNotes(c))) && isStruck(c.querySelector('*') || c)) { itemOld = c; break; }
      var inner = c.querySelectorAll('*');
      for (var j = 0; j < inner.length; j++) { if (PRICE_RE.test(squash(inner[j].textContent)) && isStruck(inner[j])) { itemOld = c; break; } }
      if (itemOld) break;
    }
    if (!itemOld) return;
    itemCur.style.setProperty('order', '-2', 'important');
    itemOld.style.setProperty('order', '-1', 'important');
  }

  function isFlexRow(el) {
    if (!el) return false;
    var cs = getComputedStyle(el);
    if (cs.display.indexOf('flex') === -1) return false;
    if (cs.flexDirection && cs.flexDirection.indexOf('column') === 0) return false;
    var n = 0;
    for (var i = 0; i < el.children.length; i++) {
      var c = el.children[i];
      if (c.classList.contains('rl-tax-note') || c.classList.contains('rl-ki-badge')) continue;
      n++;
    }
    return n > 1;
  }

  function hideSofortVerfuegbar(el, digital) {
    if (digital) return;
    var n = el.parentElement, lvl = 0;
    while (n && lvl < 2) {
      var cand = n.querySelectorAll('span,div,p,small,li');
      for (var i = 0; i < cand.length; i++) {
        var c = cand[i];
        if (c.contains(el)) continue;
        var t = (c.textContent || '').replace(/\s+/g, ' ').trim();
        if (/^(sofort verf(ü|ue)gbar|available (now|immediately)|in stock)\.?$/i.test(t)) c.style.setProperty('display', 'none', 'important');
      }
      n = n.parentElement; lvl++;
    }
  }

  function rowHasStruck(row, el) {
    for (var i = 0; i < row.children.length; i++) {
      var c = row.children[i];
      if (c === el || c.contains(el)) continue;
      var inner = [c].concat(Array.prototype.slice.call(c.querySelectorAll('*')));
      for (var j = 0; j < inner.length; j++) { if (PRICE_RE.test(squash(textWithoutOurNotes(inner[j]))) && isStruck(inner[j])) return true; }
    }
    return false;
  }

  function tightenRow(el) {
    var row = el.parentElement, depth = 0, item = el;
    while (row && depth < 3 && !isFlexRow(row)) { item = row; row = row.parentElement; depth++; }
    if (!row || !isFlexRow(row)) return;
    var hasOld = false;
    for (var i = 0; i < row.children.length; i++) {
      var c = row.children[i];
      if (c === item) continue;
      var inner = [c].concat(Array.prototype.slice.call(c.querySelectorAll('*')));
      for (var j = 0; j < inner.length; j++) { if (PRICE_RE.test(squash(textWithoutOurNotes(inner[j]))) && isStruck(inner[j])) { hasOld = true; break; } }
      if (hasOld) break;
    }
    if (!hasOld) return;
    row.style.setProperty('justify-content', 'flex-start', 'important');
    row.style.setProperty('align-items', 'baseline', 'important');
    row.style.setProperty('row-gap', '4px', 'important');
    row.style.setProperty('column-gap', '10px', 'important');
    row.style.setProperty('gap', '4px 10px', 'important');
  }

  function moveSofortDigital(el) {
    var row = el.parentElement, lvl = 0;
    while (row && lvl < 2) {
      var cand = row.querySelectorAll('span,div,p,small');
      for (var i = 0; i < cand.length; i++) {
        var c = cand[i];
        if (c.contains(el) || c.closest('.rl-tax-note') || c.getAttribute('data-rl-avail')) continue;
        var t = (c.textContent || '').replace(/\s+/g, ' ').trim();
        if (!/^(sofort digital|instant(ly)? (digital|download|access|available)|instant pdf|digital download|available (now|immediately))\.?$/i.test(t)) continue;
        c.style.setProperty('display', 'none', 'important');
        c.setAttribute('data-rl-avail', '1');
        return;
      }
      row = row.parentElement; lvl++;
    }
  }

  function taxNotes(root) {
    var all = (root || document.body).querySelectorAll('span,div,p,strong,b,dd,td,li,h2,h3,h4,h5,h6');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.hasAttribute('data-rl-tax')) continue;
      if (el.closest('button,select,option,s,del,script,style,.rl-tax-note,.rl-ki-badge,[class*="compare"],[class*="was-price"],[class*="price--old"]')) continue;
      if (el.closest('cart-items,.cart-items,#main-cart-items,#main-cart-footer,.cart__footer,.cart__blocks,.totals,.cart-item,cart-drawer,.cart-drawer,cart-notification,[id*="main-cart"],[id*="cart-items"],[id*="cart-footer"]')) continue;
      if (!PRICE_RE.test(squash(el.textContent))) continue;
      var deeper = false, kids = el.children;
      for (var k = 0; k < kids.length; k++) { if (PRICE_RE.test(squash(kids[k].textContent))) { deeper = true; break; } }
      if (deeper) continue;
      el.setAttribute('data-rl-tax', '1');
      if (isStruck(el)) continue;
      fixPriceOrder(el);
      var digital = isDigitalContext(el);
      var themeEl = findFollowingTax(el) || findThemeTaxEl(el);
      hideSofortVerfuegbar(el, digital);
      if (themeEl) {
        themeEl.setAttribute('data-rl-tax-theme', '1');
        captureStyle(themeEl);
        if (!digital) linkify(themeEl);
        var pr = el.getBoundingClientRect(), tr = themeEl.getBoundingClientRect();
        if (tr.top - pr.bottom > 30 || tr.top < pr.top) {
          themeEl.style.setProperty('display', 'block', 'important');
          themeEl.style.setProperty('margin', '4px 0 0 0', 'important');
          el.appendChild(themeEl);
          styleNote(themeEl);
        }
        continue;
      }
      if (hasExistingTaxNote(el)) continue;
      var s = document.createElement('span');
      s.className = 'rl-tax-note';
      fillNote(s, digital);
      styleNote(s);
      var prow = el.parentElement;
      var pcs = prow ? getComputedStyle(prow) : null;
      if (prow && isFlexRow(prow) && pcs.flexWrap !== 'nowrap' && rowHasStruck(prow, el)) {
        s.style.setProperty('flex-basis', '100%', 'important');
        s.style.setProperty('width', '100%', 'important');
        s.style.setProperty('order', '99', 'important');
        s.style.setProperty('margin-top', '0', 'important');
        prow.appendChild(s);
        tightenRow(el);
      } else {
        el.appendChild(s);
      }
      if (digital) moveSofortDigital(el);
    }
  }

  function badgeBox(img) {
    var box = img.parentElement;
    while (box && box !== document.body && getComputedStyle(box).display === 'inline') box = box.parentElement;
    return box;
  }

  function frameInset(img, box) {
    var best = 0;
    function check(top, right, bw) { if (bw > 0 && top >= 4 && top <= 60) best = Math.max(best, top); }
    var cands = [box, box.parentElement, box.parentElement && box.parentElement.parentElement];
    for (var i = 0; i < cands.length; i++) {
      var el = cands[i]; if (!el) continue;
      ['::before', '::after'].forEach(function (p) {
        var cs = getComputedStyle(el, p);
        if (!cs || cs.content === 'none' || cs.position !== 'absolute') return;
        check(parseFloat(cs.top) || 0, parseFloat(cs.right) || 0, parseFloat(cs.borderTopWidth) || 0);
      });
      var kids = el.children;
      for (var k = 0; k < kids.length; k++) {
        var c = kids[k];
        if (c === img || c.classList.contains('rl-ki-badge') || c.contains(img)) continue;
        var cs2 = getComputedStyle(c);
        if (cs2.position !== 'absolute') continue;
        var cr = c.getBoundingClientRect(), er = el.getBoundingClientRect();
        if (cr.width < er.width * 0.6 || cr.height < er.height * 0.6) continue;
        check(cr.top - er.top, er.right - cr.right, parseFloat(cs2.borderTopWidth) || 0);
      }
    }
    return best;
  }

  function placeBadge(b, img, box) {
    var ir0 = img.getBoundingClientRect(), br = box.getBoundingClientRect();
    if (!ir0.width || !ir0.height || !br.width) return;
    var ir = { top: ir0.top, right: ir0.right, left: ir0.left, bottom: ir0.bottom };
    var mainEl = document.querySelector('main');
    var heroH = img.closest && img.closest('header');
    var isHero = !!(heroH && mainEl && mainEl.contains(heroH));
    var cl = img.parentElement, lv = 0;
    while (cl && cl !== document.body && lv < (isHero ? 6 : 2)) {
      var ov = getComputedStyle(cl);
      if (ov.overflow !== 'visible' || ov.overflowX !== 'visible' || ov.overflowY !== 'visible') {
        var cr = cl.getBoundingClientRect();
        var iw = Math.min(ir0.right, cr.right) - Math.max(ir0.left, cr.left);
        var ih = Math.min(ir0.bottom, cr.bottom) - Math.max(ir0.top, cr.top);
        if (cr.width > 0 && cr.height > 0 && (isHero || (iw >= cr.width * 0.9 && ih >= cr.height * 0.9))) {
          ir.top = Math.max(ir.top, cr.top); ir.right = Math.min(ir.right, cr.right);
          ir.left = Math.max(ir.left, cr.left); ir.bottom = Math.min(ir.bottom, cr.bottom);
        }
      }
      cl = cl.parentElement; lv++;
    }
    var bl = parseFloat(getComputedStyle(box).borderLeftWidth) || 0, bt = parseFloat(getComputedStyle(box).borderTopWidth) || 0;
    var w = Math.min(ir.right, br.right) - Math.max(ir.left, br.left);
    var inset = 12;
    var main = document.querySelector('main');
    var heroHead = img.closest && img.closest('header');
    var insetTop = inset, insetRight = inset;
    if (heroHead && main && main.contains(heroHead)) { insetTop = 26; insetRight = 14; }
    var bannerSec = img.closest && img.closest('.shopify-section[id*="banner"], .shopify-section[id*="Banner"]');
    if (bannerSec) { insetTop = 26; insetRight = 26; }
    var top = Math.max(ir.top, br.top) - br.top - bt + insetTop;
    var right = br.right - Math.min(ir.right, br.right) - (parseFloat(getComputedStyle(box).borderRightWidth) || 0) + insetRight;
    b.style.top = Math.round(top) + 'px';
    b.style.right = Math.round(right) + 'px';
    b.style.left = 'auto';
    b.style.bottom = 'auto';
  }

  var tracked = [];
  var KI_KEY = 'rlKiFiles';
  var kiFiles = [];
  try { localStorage.removeItem(KI_KEY); } catch (e) {}
  (window.rlKiFiles || []).forEach(function (f) { if (f && kiFiles.indexOf(f) === -1) kiFiles.push(f); });
  function fileOf(u) { return (u || '').split('?')[0].split('/').pop(); }
  function remember(f) {
    if (!f || kiFiles.indexOf(f) !== -1) return;
    kiFiles.push(f);
  }
  function srcHasKiFile(str) {
    for (var i = 0; i < kiFiles.length; i++) { if (str.indexOf('/' + kiFiles[i]) !== -1) return true; }
    return false;
  }
  function excluded(el) {
    return el.closest('#shopify-section-header,#shopify-section-footer,#shopify-section-announcement-bar,.shopify-section-group-header-group,.shopify-section-group-footer-group,sticky-header,.header-wrapper,[class*="payment"],[class*="logo"],.cart-drawer,cart-drawer,.predictive-search,.rl-ki-badge');
  }

  /* KI-Hinweis als kleines Fenster. Mit der Maus geoeffnet: kein Fokus-Rahmen,
     danach bleibt nichts markiert. Mit der Tastatur: Fokus wird korrekt gefuehrt. */
  var kiOpenEl = null, kiLastFocus = null, kiByKey = false;
  function closeKi() {
    if (!kiOpenEl) return;
    var ov = kiOpenEl; kiOpenEl = null;
    ov.classList.remove('is-open');
    setTimeout(function () { if (ov.parentNode) ov.parentNode.removeChild(ov); }, 200);
    document.removeEventListener('keydown', kiKey, true);
    if (kiByKey && kiLastFocus && kiLastFocus.focus) {
      try { kiLastFocus.focus({ preventScroll: true }); } catch (e) {}
    } else if (document.activeElement && document.activeElement.blur) {
      try { document.activeElement.blur(); } catch (e) {}
    }
  }
  function kiKey(e) { if (e.key === 'Escape') { e.preventDefault(); closeKi(); } }
  function openKi(badge, byKey) {
    if (kiOpenEl) return;
    kiByKey = !!byKey;
    kiLastFocus = badge || document.activeElement;
    if (!kiByKey && badge && badge.blur) { try { badge.blur(); } catch (e) {} }
    var ov = document.createElement('div');
    ov.className = 'rl-ki-ov';
    var dlg = document.createElement('div');
    dlg.className = 'rl-ki-dlg';
    dlg.setAttribute('role', 'dialog');
    dlg.setAttribute('aria-modal', 'true');
    dlg.setAttribute('aria-labelledby', 'rl-ki-title');
    var hd = document.createElement('div');
    hd.className = 'rl-ki-hd';
    var h = document.createElement('h2');
    h.id = 'rl-ki-title';
    h.textContent = IS_EN ? 'Created with AI' : 'Mit KI generiert';
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'rl-ki-x';
    x.setAttribute('aria-label', IS_EN ? 'Close' : 'Schließen');
    x.innerHTML = '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M2 2l10 10M12 2 2 12"/></svg>';
    var p = document.createElement('p');
    p.textContent = IS_EN ? 'This image was created in whole or in part with the help of artificial intelligence.' : 'Dieses Bild wurde ganz oder teilweise mithilfe künstlicher Intelligenz erstellt.';
    hd.appendChild(h); hd.appendChild(x); dlg.appendChild(hd); dlg.appendChild(p); ov.appendChild(dlg);
    ov.addEventListener('mousedown', function (e) { if (e.target !== x && !x.contains(e.target)) e.preventDefault(); });
    ov.addEventListener('click', function (e) { if (e.target === ov) closeKi(); });
    x.addEventListener('mousedown', function (e) { e.preventDefault(); });
    x.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); closeKi(); });
    document.body.appendChild(ov);
    kiOpenEl = ov;
    requestAnimationFrame(function () { ov.classList.add('is-open'); });
    document.addEventListener('keydown', kiKey, true);
    if (kiByKey) { try { x.focus({ preventScroll: true }); } catch (e) {} }
  }
  function kiBadgeFrom(e) { return e.target && e.target.closest ? e.target.closest('.rl-ki-badge') : null; }
  ['pointerdown', 'touchstart'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { if (kiBadgeFrom(e)) e.stopPropagation(); }, { capture: true, passive: true });
  });
  document.addEventListener('mousedown', function (e) {
    if (!kiBadgeFrom(e)) return;
    e.preventDefault();
    e.stopPropagation();
  }, true);
  document.addEventListener('click', function (e) {
    var b = kiBadgeFrom(e);
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    openKi(b, e.detail === 0);
  }, true);
  document.addEventListener('keydown', function (e) {
    var b = kiBadgeFrom(e);
    if (!b || (e.key !== 'Enter' && e.key !== ' ')) return;
    e.preventDefault();
    e.stopPropagation();
    openKi(b, true);
  }, true);

  function addBadge(box, anchor) {
    if (box.querySelector(':scope > .rl-ki-badge')) return;
    if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
    var b = document.createElement('span');
    b.className = 'rl-ki-badge';
    b.textContent = IS_EN ? 'AI' : 'KI';
    b.setAttribute('role', 'button');
    b.setAttribute('tabindex', '0');
    b.setAttribute('aria-label', IS_EN ? 'Note: created with AI' : 'Hinweis: mit KI generiert');
    b.setAttribute('title', IS_EN ? 'Created with AI' : 'Mit KI generiert');
    box.appendChild(b);
    tracked.push([b, anchor, box]);
  }
  function kiBadges(root) {
    var imgs = (root || document).querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.getAttribute('data-rl-ki')) continue;
      if (excluded(img)) continue;
      var srcAll = [img.currentSrc, img.getAttribute('src'), img.getAttribute('srcset'), img.getAttribute('data-src'), img.getAttribute('data-srcset')].join(' ');
      var alt = img.getAttribute('alt') || '';
      var byAlt = /ki[\s -]*generiert/i.test(alt);
      if (byAlt) remember(fileOf(img.currentSrc || img.getAttribute('src')));
      if (!byAlt && !srcHasKiFile(srcAll)) continue;
      if (/logo|icon|payment|\.svg/i.test(srcAll)) continue;
      var r = img.getBoundingClientRect();
      if (r.width < 120 || r.height < 120) {
        if (!img.getAttribute('data-rl-kiwait')) {
          img.setAttribute('data-rl-kiwait', '1');
          img.addEventListener('load', function () { schedule(); });
        }
        continue;
      }
      var box = badgeBox(img);
      if (!box) continue;
      img.setAttribute('data-rl-ki', '1');
      addBadge(box, img);
    }
    if (kiFiles.length) {
      var scope = document.querySelector('main') || document.body;
      var bgs = scope.querySelectorAll('div,section,figure,a,span,header');
      for (var j = 0; j < bgs.length && j < 4000; j++) {
        var el = bgs[j];
        if (el.getAttribute('data-rl-ki') || el.getAttribute('data-rl-bgno') || excluded(el)) continue;
        if (el.offsetWidth < 200 || el.offsetHeight < 150) continue;
        var st = (el.getAttribute('style') || '') + ' ' + getComputedStyle(el).backgroundImage;
        if (!srcHasKiFile(st)) { el.setAttribute('data-rl-bgno', '1'); continue; }
        var rr = el.getBoundingClientRect();
        if (rr.width < 120 || rr.height < 120) continue;
        el.setAttribute('data-rl-ki', '1');
        addBadge(el, el);
      }
    }
    for (var t2 = 0; t2 < tracked.length; t2++) {
      try { if (tracked[t2][1].isConnected) placeBadge(tracked[t2][0], tracked[t2][1], tracked[t2][2]); } catch (e) {}
    }
  }

  function fitHighlightMedia() {
    var boxes = document.querySelectorAll('.rl-product-highlight__media');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i], img = box.querySelector('img');
      if (!img) continue;
      var apply = function (b, im) {
        if (!im.naturalWidth || !im.naturalHeight) return;
        b.style.setProperty('height', 'auto', 'important');
        b.style.setProperty('aspect-ratio', im.naturalWidth + ' / ' + im.naturalHeight, 'important');
        im.style.setProperty('object-fit', 'cover', 'important');
        im.style.setProperty('object-position', 'center center', 'important');
      };
      if (img.complete) apply(box, img);
      else img.addEventListener('load', (function (b, im) { return function () { apply(b, im); schedule(); }; })(box, img), { once: true });
    }
  }

  function styleFooterSelectors() {
    var btns = document.querySelectorAll('footer .localization-form__select');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      if (b.getAttribute('data-rl-loc')) continue;
      b.setAttribute('data-rl-loc', '1');
      var p = [['min-height','28px'],['padding','4px 30px 4px 10px'],['border','1px solid rgba(190,155,125,.24)'],['border-radius','8px'],['background','rgba(255,255,255,.72)'],['background-clip','padding-box'],['box-shadow','none'],['font-size','11px'],['letter-spacing','.02em'],['line-height','1.2']];
      for (var k = 0; k < p.length; k++) b.style.setProperty(p[k][0], p[k][1], 'important');
    }
    var ft = document.querySelector('footer[id^="RLFooter-"]');
    if (ft && !document.getElementById('rl-footer-layout')) {
      var id = '#' + ft.id + '#' + ft.id;
      var fcss = '@media screen and (min-width:750px){' +
        id + ' .footer__content-bottom-wrapper{grid-template-columns:minmax(0,1fr) auto!important;align-items:end!important;row-gap:10px!important}' +
        id + ' .footer__localization{grid-column:1!important;grid-row:1!important;align-self:end!important}' +
        id + ' .footer__column--info{grid-column:2!important;grid-row:1!important;align-self:end!important;justify-self:end!important;display:flex!important;flex-direction:column!important;align-items:flex-end!important;gap:6px!important;width:auto!important;margin-bottom:12px!important}' +
        id + ' .footer__payment{width:auto!important}' +
        id + ' .footer__copyright{width:auto!important;justify-content:flex-end!important}' +
        '}';
      var fst = document.createElement('style');
      fst.id = 'rl-footer-layout';
      fst.textContent = fcss;
      document.head.appendChild(fst);
    }
    var labels = document.querySelectorAll('footer .localization-form h2');
    for (var j = 0; j < labels.length; j++) {
      labels[j].style.setProperty('font-size', '11px', 'important');
      labels[j].style.setProperty('letter-spacing', '.02em', 'important');
      labels[j].style.setProperty('line-height', '1.2', 'important');
    }
  }

  function cartShippingText() {
    var scope = document.querySelectorAll('#main-cart-footer,.cart__footer,.totals,.tax-note,cart-drawer,.cart-drawer,[id*="cart-footer"]');
    for (var i = 0; i < scope.length; i++) {
      var w = document.createTreeWalker(scope[i], NodeFilter.SHOW_TEXT, null), n;
      while ((n = w.nextNode())) {
        if (/wird beim Checkout berechnet/.test(n.nodeValue) && !/ggf\./.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace('wird beim Checkout berechnet', 'wird ggf. beim Checkout berechnet');
        if (/calculated at checkout/i.test(n.nodeValue) && !/if applicable/i.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/calculated at checkout/i, 'calculated at checkout if applicable');
      }
    }
  }

  function marqueeLinks() {
    var inert = document.querySelectorAll('.rl-ann-marquee [inert]');
    for (var i = 0; i < inert.length; i++) { inert[i].inert = false; inert[i].removeAttribute('inert'); }
  }

  function primeStyle() {
    var c = document.querySelectorAll('p,span,div,small');
    for (var i = 0; i < c.length; i++) {
      var el = c[i];
      if (el.closest('.rl-tax-note')) continue;
      var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (t.length > 60 || !TAX_RE.test(t)) continue;
      var deeper = false;
      for (var k = 0; k < el.children.length; k++) { if (TAX_RE.test(el.children[k].textContent || '')) { deeper = true; break; } }
      if (!deeper) { captureStyle(el); return; }
    }
  }
  var primed = false;
  function run() { try { if (!primed) { primeStyle(); primed = true; } fitHighlightMedia(); styleFooterSelectors(); marqueeLinks(); cartShippingText(); taxNotes(); kiBadges(); } catch (e) {} }
  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(run, 250); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  setTimeout(run, 1500);
  window.addEventListener('resize', schedule);
  window.addEventListener('scroll', schedule, { passive: true });
  document.addEventListener('click', function () { setTimeout(schedule, 50); setTimeout(schedule, 600); }, true);
  document.addEventListener('transitionend', schedule, true);
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  setTimeout(run, 3500);
  setTimeout(run, 7000);
  document.addEventListener('DOMContentLoaded', function () {
    if (!window.MutationObserver) return;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes, ours = true;
        for (var k = 0; k < added.length; k++) {
          var a = added[k];
          if (!(a.nodeType === 1 && a.classList && (a.classList.contains('rl-tax-note') || a.classList.contains('rl-ki-badge') || a.classList.contains('rl-ki-ov')))) { ours = false; break; }
        }
        if (!ours || !added.length) { schedule(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
